module.exports = __webpack_public_path__ + "static/media/New_Series_3_Ep8_Turning_back_the_climate_clock_Tablet.36ab2688.jpg";